import { RouterProvider } from "react-router-dom";
import router from "./routes.jsx";

export default function App() {
  return <RouterProvider router={router} fallbackElement={<div className="tgwe-loading">Loading</div>} />;
}
